import EngineProvider from './engineProvider';

export const getEngineTemplatesAsync = EngineProvider.getEngineTemplatesAsync;

export const getEngineByIdAsync = EngineProvider.getEngineByIdAsync;

export const updateEngineAsync = EngineProvider.updateEngineAsync;

export const updateEngineWithImageAsync = EngineProvider.updateEngineWithImageAsync;

export const insertEngineWithImageAsync = EngineProvider.insertEngineWithImageAsync;

export const getAllEnginePreviewsAsync = EngineProvider.getAllEnginePreviewsAsync;

export const getEnginesByVesselAsync = EngineProvider.getEnginesByVesselAsync;

export const updateSelectedEnginesWithImageAndTranslationAsync = EngineProvider.updateSelectedEnginesWithImageAndTranslationAsync;
